<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ 'reports.details.title' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    @if (report()) {
      <div class="d-flex justify-content-between align-items-end mb-1">
        <p class="caption mb-1">
          {{ 'reports.details.baseInfo' | translate }}
        </p>
        <div class="text-end col-3">
          <button
            *appRequirePermission="'reports'"
            class="icon-btn mb-1 me-2"
            [ngbTooltip]="'reports.details.tooltips.resultDetails' | translate"
            triggers="hover"
            Placement="left"
            type="submit"
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            [disabled]="!report()?.rawDataId"
            (click)="resultsUtilsService.openResultDetails(report().rawDataId)"
          >
            <i class="fa-light fa-table-list fa-fw"></i>
          </button>

          <button
            *appRequirePermission="'reports.reportsList.buttons.view'"
            class="icon-btn mb-1 me-2"
            [ngbTooltip]="'reports.details.tooltips.viewReport' | translate"
            triggers="hover"
            Placement="left"
            type="submit"
            [disabled]="report().invalidated"
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            (click)="reportsUtils.viewReport(reportId())"
          >
            <i class="fa-light fa-eye fa-fw"></i>
          </button>
          <button
            *appRequirePermission="'reports.reportsList.buttons.manage'"
            class="icon-btn mb-1 me-2"
            [ngbTooltip]="'reports.details.tooltips.editReport' | translate"
            triggers="hover"
            Placement="left"
            type="submit"
            [disabled]="
              !report().analysisData ||
              report().reportType !== ReportType.Official
            "
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            (click)="reportsUtils.openEditReportDialog(reportId())"
          >
            <i class="fa-light fa-pencil fa-fw"></i>
          </button>
          <button
            *appRequirePermission="'followUps'"
            class="icon-btn mb-1 me-2"
            [ngbTooltip]="'reports.details.tooltips.followUps' | translate"
            triggers="hover"
            Placement="left"
            type="submit"
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            (click)="
              followUpsUtils.openFollowUpsListDialog(report().followUpIds)
            "
          >
            <i class="fa-light fa-square-exclamation fa-fw"></i>
          </button>
          <button
            *appRequirePermission="'pii.buttons.details'"
            class="icon-btn mb-1 me-2"
            [ngbTooltip]="
              'reports.details.tooltips.productInventoryItem' | translate
            "
            triggers="hover"
            Placement="left"
            type="submit"
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            (click)="piiUtils.openDetails(report().productInventoryItemId)"
          >
            <i class="fa-light fa-clipboard fa-fw"></i>
          </button>
        </div>
      </div>
      <hr class="mt-0" />
      <div class="mb-3">
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.kitId' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ properties().kitid }}</div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.partner' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ partner()?.name }}</div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.laboratory' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">
            {{ Util.PropertiesToObject(report().properties)?.laboratory }}
          </div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.analysisType' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">
            {{ Util.PropertiesToObject(report().properties)?.analysistype }}
          </div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.version' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">v{{ report().version }}</div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.reportType' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ report().reportType }}</div>
        </div>
        @if (report().reportedRisk) {
          <div class="row mb-2 mb-sm-0">
            <div class="col-12 col-sm-5 mb-sm-2">
              <label class="label">{{
                'reports.details.reportedRisk' | translate
              }}</label>
            </div>
            <div class="col-12 col-sm-7">{{ report().reportedRisk }}</div>
          </div>
        }
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.product' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ product()?.internalName }}</div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.signee' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">
            {{ signeeById()(report().signeeId)?.name ?? '/' }}
          </div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.country' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">
            {{ Util.PropertiesToObject(report().properties)?.country }}
          </div>
        </div>
        <div class="row mb-2 mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.reportReason' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ report().reportReason ?? '/' }}</div>
        </div>
        <div class="row mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.generated' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ report().generated | date }}</div>
        </div>
        <div class="row mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.status' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">
            {{ 'reports.list.status.' + report().status | translate }}
          </div>
        </div>
        <div class="row mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.template' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ template()?.name ?? '/' }}</div>
        </div>
        <div class="row mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.scheme' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">{{ scheme()?.name ?? '/' }}</div>
        </div>
        <div class="row mb-sm-0">
          <div class="col-12 col-sm-5 mb-sm-2">
            <label class="label">{{
              'reports.details.reportLanguage' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-7">
            {{ reportLanguageById()(report().languageId)?.name ?? '/' }}
          </div>
        </div>
      </div>
      @if (report().status === ReportStatus.Invalid) {
        <div class="mb-3">
          <p class="caption mb-1">
            {{ 'reports.details.invalidValuesTitle' | translate }}
          </p>
          <hr class="mt-0" />
          <app-data-table
            [configuration]="failedReasonDataTableConfiguration"
          />
        </div>
      }
      <div class="mb-1">
        <p class="caption mb-1">
          {{ 'reports.details.connectedReports' | translate }}
        </p>
        <hr class="mt-0" />
        <app-data-table [configuration]="connectedReportsDataTable" />
      </div>
    } @else {
      <div class="py-4 loading"></div>
    }
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      (click)="dismiss()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>

<ng-template #statusTemplate let-report="row">
  @switch (report.status) {
    @case (ReportStatus.Generated) {
      <div class="text-blue">
        {{ 'reports.list.status.Generated' | translate }}
      </div>
    }
    @case (ReportStatus.Invalid) {
      <div class="text-danger">
        {{ 'reports.list.status.Invalid' | translate }}
      </div>
    }
    @case (ReportStatus.Approved) {
      <div class="text-success">
        {{ 'reports.list.status.Approved' | translate }}
      </div>
    }
    @case (ReportStatus.Archived) {
      <div class="text-warning">
        {{ 'reports.list.status.Archived' | translate }}
      </div>
    }
  }
</ng-template>
